import { Controller, useFormContext, useFormState } from 'react-hook-form';
import { getErrorByPath } from '../formComponents.utils';
import BaseCheckboxSelect from './BaseCheckboxSelect';

/**
 * @component ControlledCheckboxSelect
 *
 * React Hook Form wrapper for BaseCheckboxSelect.
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {Object} [props.rules]
 * @param {boolean} [props.showErrorInline=true]
 * @param {boolean} [props.reserveErrorSpace=false]
 * @returns {React.ReactElement}
 */
export default function ControlledCheckboxSelect(props: any) {
  const { name, rules, showErrorInline = true, reserveErrorSpace = false, ...rest } = props;

  const { control } = useFormContext();
  const { errors } = useFormState({ name });

  const error = getErrorByPath(errors, name);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={[]}
      render={({ field }) => (
        <BaseCheckboxSelect
          {...rest}
          value={field.value}
          onChange={field.onChange}
          error={Boolean(showErrorInline && error)}
          errorMessage={showErrorInline ? error?.message : undefined}
          reserveErrorSpace={reserveErrorSpace}
        />
      )}
    />
  );
}
